import axios, { AxiosError } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { LIST_PATH, TAX_PLAN_PATH } from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getTaxPlansService = async () => {
  try {
    const result = await instance.get(TAX_PLAN_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createTaxPlanService = async (taxPlan: any) => {
  try {
    const result = await instance.post(TAX_PLAN_PATH, taxPlan)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteTaxPlanService = async (id: any) => {
  try {
    const result = await instance.delete(TAX_PLAN_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editTaxPlanService = async (id: number, taxPlan: any) => {
  try {
    const result = await instance.put(TAX_PLAN_PATH + `/${id}`, taxPlan)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
